import React, { useCallback, useEffect, useRef } from "react";
import styles from "./PickADay.module.css";
import { PickADayMonth } from "./PickADayMonth";
import { type MonthInfo } from "../../types/date";
import { type Locale } from "./text.i18n";
import { usePickADayContext } from "./PickADayContext";

interface PickADayCalendarProps {
  monthsNamesList: MonthInfo[];
  locale: Locale;
}

export const PickADayCalendar: React.FC<PickADayCalendarProps> = ({
  monthsNamesList,
  locale,
}) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const { setScrollPercent, scrollPercent, year } = usePickADayContext();

  const handleScroll = useCallback(() => {
    const scrollTop: number = scrollRef.current?.scrollTop || 0;
    const offsetHeight: number = scrollRef.current?.offsetHeight || 0;
    const scrollHeight: number = scrollRef.current?.scrollHeight || 0;

    const height: number = scrollHeight - offsetHeight;
    const onePercent: number = height / 100;
    const percent: number = scrollTop / onePercent;
    setScrollPercent(percent);
  }, [setScrollPercent]);

  useEffect(() => {
    const offsetHeight: number = scrollRef.current?.offsetHeight || 0;
    const scrollHeight: number = scrollRef.current?.scrollHeight || 0;
    const height: number = scrollHeight - offsetHeight;
    const onePercent: number = height / 100;

    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollPercent * onePercent;
    }
  }, [scrollPercent]);

  return (
    <div
      className={styles.PickADay__calendar}
      onScroll={handleScroll}
      ref={scrollRef}
    >
      {monthsNamesList.map(({ name, id }) => (
        <PickADayMonth
          key={id}
          locale={locale}
          id={id}
          name={name}
          year={year}
        />
      ))}
    </div>
  );
};
